import { forwardRef } from 'react';

export const CustomButton = forwardRef((props, ref) => {
  return (
    <button {...props} data-tip ref={ref as any}>
      {props.children}
    </button>
  );
});
